export const makeSafePharmacyAddress = ({ address, city, state }) =>
  [address, [city, state].filter(Boolean).join(', ')]
    .filter(Boolean)
    .join(',\n');



// WEBPACK FOOTER //
// ./src/utils/appointments/makeSafePharmacyAddress.js